module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    staticStyle: {
      "width": "550px"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "to-kusha-and-to-the-earth-we-walked."
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "right",
      "padding-top": "300px",
      "font-size": "12pt",
      "font-family": "calibri",
      "width": "550px"
    }
  }, [_c('em', [_vm._v("To Kusha, and to the Earth we walked.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda61350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0003.vue
// module id = 66
// module chunks = 0